import { useEffect, useMemo, useState } from "react";
import { Download } from "lucide-react";
import { api, inr, downloadCsv } from "@/lib/api";

export default function AdminReports() {
  const [gst, setGst] = useState(null);
  useEffect(() => { api.get("/admin/reports/gst").then((r) => setGst(r.data)); }, []);
  const rates = useMemo(() => [...(gst?.by_rate || [])].sort((a, b) => a.rate - b.rate), [gst]);
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-2xl font-bold">Reports & GST</h1>
        <div className="flex gap-2">
          <button data-testid="export-orders-csv" onClick={() => downloadCsv("/admin/export/orders.csv", "orders.csv")} className="px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm font-semibold flex items-center gap-1.5 hover:bg-slate-50"><Download size={15} /> Orders CSV</button>
          <button data-testid="export-gst-csv" onClick={() => downloadCsv("/admin/export/gst.csv", "gst_report.csv")} className="px-3 py-2 bg-emerald-600 text-white rounded-lg text-sm font-semibold flex items-center gap-1.5 hover:bg-emerald-700"><Download size={15} /> GST CSV</button>
        </div>
      </div>
      {gst && <>
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="bg-white rounded-xl border border-slate-200 p-5"><p className="text-xs font-semibold uppercase text-slate-500">Total Taxable Value</p><p className="text-3xl font-extrabold mt-1">{inr(gst.total_taxable)}</p></div>
          <div className="bg-white rounded-xl border border-slate-200 p-5"><p className="text-xs font-semibold uppercase text-slate-500">Total GST Collected</p><p className="text-3xl font-extrabold mt-1 text-emerald-600">{inr(gst.total_gst)}</p></div>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
          <div className="px-4 py-3 border-b border-slate-100 font-bold">GST Breakup by Rate</div>
          <table className="w-full text-sm"><thead><tr className="text-xs font-bold uppercase text-slate-500 bg-slate-50"><th className="text-left py-3 px-4">GST Rate</th><th className="text-right py-3 px-4">Taxable Value</th><th className="text-right py-3 px-4">GST Amount</th></tr></thead>
            <tbody>{rates.map((r) => (
              <tr key={r.rate} data-testid={`gst-rate-${r.rate}`} className="border-b border-slate-50"><td className="py-3 px-4 font-semibold">{r.rate}%</td><td className="py-3 px-4 text-right">{inr(r.taxable)}</td><td className="py-3 px-4 text-right font-semibold">{inr(r.gst)}</td></tr>
            ))}</tbody></table>
        </div>
      </>}
    </div>
  );
}
